"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var errors_1 = require("./errors");
var checkFunctions_1 = require("./checkFunctions");
exports.t = {
    boolean: boolean,
    number: number,
    string: string,
    any: any,
    never: never,
    undefined: undefinedSpec,
    null: nullSpec,
    unknown: unknown,
    array: array,
    or: or,
    tuple: tuple,
    partial: partial,
    nullPartial: nullPartial,
    spec: spec,
    object: object,
    literal: literal,
    record: record,
};
///////////////////
///////////////////
///////////////////
function any() {
    function typeChecker(val) {
        return val;
    }
    typeChecker.toSpecString = function () { return "any"; };
    return typeChecker;
}
exports.any = any;
any.toSpec = function () { return any(); };
///////////////////
///////////////////
///////////////////
function unknown() {
    function typeChecker(val) {
        return val;
    }
    typeChecker.toSpecString = function () { return "unknown"; };
    return typeChecker;
}
exports.unknown = unknown;
unknown.toSpec = function () { return unknown(); };
///////////////////
///////////////////
///////////////////
function undefinedSpec() {
    function typeChecker(val) {
        if (typeof val !== "undefined") {
            throw new errors_1.SpecError("expected undefined, but got " + utils_1.describe(val));
        }
        return val;
    }
    typeChecker.toSpecString = function () { return "undefined"; };
    return typeChecker;
}
exports.undefinedSpec = undefinedSpec;
undefinedSpec.toSpec = function () { return undefinedSpec(); };
///////////////////
///////////////////
///////////////////
function nullSpec() {
    function typeChecker(val) {
        if (val !== null) {
            throw new errors_1.SpecError("expected null, but got " + utils_1.describe(val));
        }
        return val;
    }
    typeChecker.toSpecString = function () { return "null"; };
    return typeChecker;
}
exports.nullSpec = nullSpec;
nullSpec.toSpec = function () { return nullSpec(); };
///////////////////
///////////////////
///////////////////
function never() {
    function typeChecker(val) {
        throw new errors_1.SpecError("expected to never occur, but got " + utils_1.describe(val));
    }
    typeChecker.toSpecString = function () { return "never"; };
    return typeChecker;
}
exports.never = never;
never.toSpec = function () { return never(); };
///////////////////
///////////////////
///////////////////
function string(options) {
    if (options === void 0) { options = {}; }
    function typeChecker(val) {
        if (typeof val !== "string") {
            throw new errors_1.SpecError("expected string, but got " + utils_1.describe(val));
        }
        else {
            if (options.trim) {
                val = val.trim();
            }
            if (options.match) {
                if (!options.match.exec(val)) {
                    throw new errors_1.SpecError("expected string matching /" + options.match.source + "/, but got " + utils_1.describe(val));
                }
            }
            if ("minLength" in options && options.minLength) {
                if (val.length < options.minLength) {
                    throw new errors_1.SpecError("expected string with at least " + options.minLength + " character" + (options.minLength === 1 ? "" : "s") + ", but got " + utils_1.describe(val));
                }
            }
            if ("maxLength" in options && options.maxLength) {
                if (val.length > options.maxLength) {
                    throw new errors_1.SpecError("expected string with at most " + options.maxLength + " character" + (options.maxLength === 1 ? "" : "s") + ", but got " + utils_1.describe(val));
                }
            }
            return val;
        }
    }
    typeChecker.toSpecString = function () { return "string"; };
    return typeChecker;
}
exports.string = string;
string.toSpec = function () { return string(); };
///////////////////
///////////////////
///////////////////
function number(options) {
    if (options === void 0) { options = {}; }
    function typeChecker(val) {
        if (typeof val !== "number") {
            throw new errors_1.SpecError("expected number, but got " + utils_1.describe(val));
        }
        if (typeof options.lessThan !== "undefined") {
            if (val >= options.lessThan) {
                throw new errors_1.SpecError("expected number lower than " + options.lessThan + ", but got " + utils_1.describe(val));
            }
        }
        if (typeof options.moreThan !== "undefined") {
            if (val <= options.moreThan) {
                throw new errors_1.SpecError("expected number higher than " + options.moreThan + ", but got " + utils_1.describe(val));
            }
        }
        if (options.integer !== undefined) {
            if (!Number.isInteger(val)) {
                throw new errors_1.SpecError("expected integer, but got " + utils_1.describe(val));
            }
        }
        return val;
    }
    typeChecker.toSpecString = function () { return "number"; };
    return typeChecker;
}
exports.number = number;
number.toSpec = function () { return number(); };
///////////////////
///////////////////
///////////////////
function boolean() {
    function typeChecker(val) {
        if (typeof val !== "boolean") {
            throw new errors_1.SpecError("expected boolean, but got " + utils_1.describe(val));
        }
        return val;
    }
    typeChecker.toSpecString = function () { return "boolean"; };
    return typeChecker;
}
exports.boolean = boolean;
boolean.toSpec = function () { return boolean(); };
///////////////////
///////////////////
///////////////////
/**
 * Expect an array of the given types:
 *
 * `t.array(t.string, t.number) -> (string | number)[]`
 */
function array() {
    var type = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        type[_i] = arguments[_i];
    }
    if (type.length === 0) {
        type = [never];
    }
    var elType = or.apply(void 0, type);
    var description = type.length > 1 ? "(" + utils_1.describe(elType) + ")[]" : utils_1.describe(elType) + "[]";
    function typeChecker(val) {
        if (!Array.isArray(val)) {
            throw new errors_1.SpecError("expected " + description + ", but got " + utils_1.describe(val));
        }
        var results = val.map(function (subvalue, i) {
            try {
                return checkFunctions_1.invariant(subvalue, elType);
            }
            catch (e) {
                if (!errors_1.SpecError.isSpecError(e))
                    throw e;
                e.path.unshift(String(i));
                return e;
            }
        });
        var errors = results.filter(function (x) { return errors_1.SpecError.isSpecError(x); });
        if (errors.length === 0) {
            return results;
        }
        throw errors_1.mostSpecificError(errors);
    }
    typeChecker.toSpecString = function () { return description; };
    return typeChecker;
}
exports.array = array;
array.toSpec = function () { return array(); };
/**
 * Expect any one of the given types:
 *
 * `t.or(t.string, t.number) -> string | number`
 */
function or() {
    var types = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        types[_i] = arguments[_i];
    }
    if (types.length === 0)
        return never();
    var description = types.map(utils_1.describe).join(" | ");
    function typeChecker(val) {
        var errors = [];
        for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
            var subtype = types_1[_i];
            try {
                return checkFunctions_1.invariant(val, subtype);
            }
            catch (e) {
                if (!errors_1.SpecError.isSpecError(e))
                    throw e;
                if (e.path.length > 0)
                    errors.push(e);
            }
        }
        if (errors.length === 0) {
            throw new errors_1.SpecError("expected " + description + ", but got " + utils_1.describe(val));
        }
        throw errors_1.mostSpecificError(errors);
    }
    typeChecker.toSpecString = function () { return description; };
    return typeChecker;
}
exports.or = or;
or.toSpec = function () {
    throw new Error("it seems you passed t.or directly to a spec method, rather then t.or()");
};
///////////////////
///////////////////
///////////////////
/**
 * Expect an exact tuple (fixed-size array) of the given types, in order:
 *
 * `t.tuple(t.string, t.number) -> [string, number]`
 */
function tuple() {
    var types = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        types[_i] = arguments[_i];
    }
    var description = "[" + types.map(utils_1.describe).join(", ") + "]";
    function typeChecker(value) {
        if (!Array.isArray(value)) {
            throw new errors_1.SpecError("expected array, but got " + utils_1.describe(value));
        }
        if (value.length !== types.length) {
            throw new errors_1.SpecError("expected " + description + ", but got " + utils_1.describe(value));
        }
        var results = types.map(function (subtype, i) {
            try {
                return checkFunctions_1.invariant(value[i], subtype);
            }
            catch (e) {
                if (!errors_1.SpecError.isSpecError(e))
                    throw e;
                e.path.unshift(String(i));
                return e;
            }
        });
        var errors = results.filter(function (x) { return errors_1.SpecError.isSpecError(x); });
        if (errors.length === 0) {
            return results;
        }
        throw errors_1.mostSpecificError(errors);
    }
    typeChecker.isTuple = types;
    typeChecker.toSpecString = function () { return description; };
    return typeChecker;
}
exports.tuple = tuple;
tuple.toSpec = function () {
    throw new Error("it seems you passed t.tuple directly to a spec method, rather then t.tuple()");
};
///////////////////
///////////////////
///////////////////
function object(types, options) {
    if (options === void 0) { options = {}; }
    var _a = options.allowUnknownKeys, allowUnknownKeys = _a === void 0 ? false : _a;
    function typeChecker(val) {
        if (typeof val !== "object" || Array.isArray(val) || !val) {
            throw new errors_1.SpecError("expected object, but got " + utils_1.describe(val));
        }
        if (types === undefined) {
            return val;
        }
        var typeKeys = Object.keys(types);
        var valKeys = Object.keys(val);
        var extraKeys = valKeys.filter(function (key) { return !typeKeys.includes(key); });
        var missingKeys = typeKeys.filter(function (key) { return !valKeys.includes(key) && !checkFunctions_1.is(undefined, types[key]); });
        var givenKeys = typeKeys.filter(function (key) { return valKeys.includes(key); });
        if (extraKeys.length > 0) {
            if (allowUnknownKeys) {
                val = __assign({}, val);
                extraKeys.forEach(function (k) { return delete val[k]; });
            }
            else {
                var keys = extraKeys.map(function (key) { return JSON.stringify(key); }).join();
                throw new errors_1.SpecError("unexpected key" + (extraKeys.length === 1 ? "" : "s") + " " + keys + " in object");
            }
        }
        if (missingKeys.length > 0) {
            var keys = missingKeys.map(function (key) { return JSON.stringify(key); }).join();
            throw new errors_1.SpecError("missing key" + (missingKeys.length === 1 ? "" : "s") + " " + keys + " in object");
        }
        var newObj = {};
        for (var _i = 0, givenKeys_1 = givenKeys; _i < givenKeys_1.length; _i++) {
            var key = givenKeys_1[_i];
            var type = types[key];
            var value = val[key];
            try {
                newObj[key] = checkFunctions_1.invariant(value, type);
            }
            catch (e) {
                if (!(e instanceof errors_1.SpecError)) {
                    throw e;
                }
                e.path.unshift(key);
                throw e;
            }
        }
        return newObj;
    }
    typeChecker.toSpecString = function () { return (types ? utils_1.describe(types) : "{}"); };
    return typeChecker;
}
exports.object = object;
object.toSpec = function () { return object(); };
function literal(type) {
    function typeChecker(val) {
        if (val !== type) {
            throw new errors_1.SpecError("expected " + utils_1.describe(type) + ", but got " + utils_1.describe(val));
        }
        else {
            return val;
        }
    }
    typeChecker.toSpecString = function () { return utils_1.describe(type); };
    return typeChecker;
}
exports.literal = literal;
literal.toSpec = function () {
    throw new Error("it seems you passed t.literal directly to a spec method, rather then t.literal()");
};
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
///////////////////
/**
 * Short hand for objects for which all keys are optional:
 *
 * `t.partial({ a: t.string }) -> { a: string | undefined }`
 */
function partial(type) {
    if (!utils_1.isObject(type)) {
        throw new Error("t.partial only accepts objects");
    }
    var partialObj = {};
    for (var key in type) {
        partialObj[key] = [type[key], exports.t.undefined()];
    }
    return partialObj;
}
/**
 * Allow any value of the given object to be null:
 *
 * `t.nullableValues({ a: t.string }) -> { a: string | null }`
 */
function nullPartial(type) {
    if (!utils_1.isObject(type)) {
        throw new Error("t.partial only accepts objects");
    }
    var partialObj = {};
    for (var key in type) {
        partialObj[key] = [type[key], exports.t.null()];
    }
    return partialObj;
}
exports.nullPartial = nullPartial;
/**
 * Returns the input spec with narrow typing, allowing it to be stored in a variable without losing
 * typescript detail.
 */
function spec(type) {
    return type;
}
function record() {
    var type = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        type[_i] = arguments[_i];
    }
    if (type.length === 0) {
        type = [never];
    }
    var elType = or.apply(void 0, type);
    var description = "{ [key]: " + utils_1.describe(elType) + " }";
    function typeChecker(val) {
        if (!utils_1.isObject(val)) {
            throw new errors_1.SpecError("expected " + description + ", but got " + utils_1.describe(val));
        }
        var errors = [];
        var result = {};
        for (var k in val) {
            try {
                result[k] = checkFunctions_1.invariant(val[k], elType);
            }
            catch (e) {
                if (!errors_1.SpecError.isSpecError(e))
                    throw e;
                e.path.unshift(k);
                errors.push(e);
            }
        }
        if (errors.length === 0) {
            return result;
        }
        throw errors_1.mostSpecificError(errors);
    }
    typeChecker.toSpecString = function () { return description; };
    return typeChecker;
}
record.toSpec = function () { return record(); };
